import React from 'react';
import { useMachine } from '@xstate/react';
import { createSender } from 'unitx/xstate';
export default ((stateMachine, options) => {
  // @ts-ignore
  const [current, send, interpreter] = useMachine(stateMachine, options);
  const sender = React.useMemo(() => createSender(stateMachine, // @ts-ignore
  interpreter), [stateMachine]); // @ts-ignore

  interpreter.sender = sender;
  return {
    current,
    sender,
    send,
    interpreter
  };
});